import { connect } from 'react-redux';

import { IPriceDisclaimerProps, PriceDisclaimer } from '../../components/PriceDisclaimer';
import { IState } from '../../store';
import { getVillageOffersType } from '../../utils/getVillageOffersType';

export type TStoreProps = Pick<IPriceDisclaimerProps, 'type'>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    type: getVillageOffersType(state),
  };
}

export const PriceDisclaimerContainer = connect<TStoreProps>(mapStateToProps)(PriceDisclaimer);
